import { useNavigate } from 'react-router';
import format from 'date-fns/format'

export interface ICardProps {
    date: number;
    title: string;
    excerpt: string;
    imageUrl?: string;
    readMoreUrl: string | (() => void);
    isInternalUrl: boolean;
    noImagePlaceholder?: string;
}

export default function Card(props: ICardProps) {
    const nav = useNavigate();

    const onReadMore = () => {
        if(typeof props.readMoreUrl === 'string') {
            if (props.isInternalUrl) {
                nav(props.readMoreUrl);
            } else {
                window.open(props.readMoreUrl, '_blank');
            }
        } else {
            props.readMoreUrl();
        }
    };

    return (
        <div className="card-container">
            <div className="card">
                <div className="header">
                    <img src={props.imageUrl || props.noImagePlaceholder} alt="Article Thumbnail" />
                </div>

                <div className="body">
                    <div className="content">
                        <label>{format(props.date, 'dd/MM/y')}</label>
                        <h6>{props.title}</h6>
                        <p>{props.excerpt}</p>
                    </div>

                    <div className="flex">
                        <button className='btn primary medium' onClick={() => onReadMore()}>
                            Read more
                            <svg style={{ marginLeft: '10px' }} xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                                <path d="M8 1L13 6M13 6L8 11M13 6H1" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}